import Vue from 'vue'
import GAuth from 'vue-google-oauth2'

const gauthOption = {
  clientId: process.env.VUE_APP_GDRIVE_CLIENT_ID,
  scope: 'https://www.googleapis.com/auth/drive.file',
  prompt: 'consent'
}
Vue.use(GAuth, gauthOption)
